import React from "react";
import { Box } from "@mui/material";
import { FONT_SIZE } from "../../../../constants/fontSizes";

/**
 * ユーザー向けサジェストウィジェット本文
 */
export default function ProjectHelpBodyUser({ formState }) {
  // Stepper から渡された「表示対象の contents」
  const contents = formState?.page_type?.contents;

  // 配列前提
  if (!Array.isArray(contents) || contents.length === 0) return null;

  const lines = contents.map((l) => String(l).trim()).filter(Boolean);

  if (lines.length === 0) return null;

  return (
    <Box sx={{ px: 2, py: 1.5, maxHeight: 250, overflowY: "auto" }}>
      <Box
        component="ul"
        sx={{
          m: 0,
          pl: 2,
          fontSize: FONT_SIZE.SM,
          listStyle: "disc",
          listStylePosition: "outside",
        }}
      >
        {lines.map((text, idx) => (
          <Box
            component="li"
            key={idx}
            sx={{
              display: "list-item",
              listStyle: "disc",
            }}
          >
            {text}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
